<template>
  <div class="user_wrap">
    <div class="top_header">
      <router-link
        to="/sign"
        class="set_go"
        aria-label="签到日历"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 256 256"
        >
          <path
            fill="currentColor"
            d="M208 32h-24V24a8 8 0 0 0-16 0v8H88V24a8 8 0 0 0-16 0v8H48a16 16 0 0 0-16 16v160a16 16 0 0 0 16 16h160a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16m0 176H48V96h160Zm0-128H48V48h24v8a8 8 0 0 0 16 0v-8h80v8a8 8 0 0 0 16 0v-8h24ZM92 128a12 12 0 1 1-12-12a12 12 0 0 1 12 12m48 0a12 12 0 1 1-12-12a12 12 0 0 1 12 12m48 0a12 12 0 1 1-12-12a12 12 0 0 1 12 12m-96 48a12 12 0 1 1-12-12a12 12 0 0 1 12 12m48 0a12 12 0 1 1-12-12a12 12 0 0 1 12 12m48 0a12 12 0 1 1-12-12a12 12 0 0 1 12 12"
          />
        </svg>
      </router-link>
      <div class="user_detail">
        <div class="user_header">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="28"
            height="28"
            viewBox="0 0 256 256"
            aria-label="用户头像"
          >
            <path
              fill="currentColor"
              d="M230.92 212c-15.23-26.33-38.7-45.21-66.09-54.16a72 72 0 1 0-73.66 0c-27.39 8.94-50.86 27.82-66.09 54.16a8 8 0 1 0 13.85 8c18.84-32.56 52.14-52 89.07-52s70.23 19.44 89.07 52a8 8 0 1 0 13.85-8M72 96a56 56 0 1 1 56 56a56.06 56.06 0 0 1-56-56"
            />
          </svg>
        </div>
        <div class="identity">
          <div class="identity_line">
            <span class="display_name">{{ data.display_name || data.mobile }}</span>
            <span class="credit_score">（信誉分：{{ data.credit_score === undefined ? 100 : data.credit_score }}）</span>
          </div>
          <p class="vip_greeting">
            {{ $t('user.welcome') }}{{ data.vip_name }}
          </p>
        </div>
      </div>
      <div class="user_balance">
        <div class="balance_label">
          {{ $t('user.totalBalance') }}
          <van-icon
            :name="eye==1?'eye-o':'closed-eye'"
            @click="eye=eye==1?0:1"
          />
        </div>
        <div class="balance_amount">
          {{ eye==1 ? $t('utils.moneyMark')+data.all_money : '******' }}
        </div>
      </div>
      <div class="user_money">
        <div><p>{{ $t('user.uncollectedPrincipal') }}</p><p>{{ eye==1 ? '+'+$t('utils.moneyMark')+data.wait_money : '******' }}</p></div>
        <div><p>{{ $t('user.uncollectedInterest') }}</p><p>{{ eye==1 ? '+'+$t('utils.moneyMark')+data.wait_lixi : '******' }}</p></div>
        <div><p>{{ $t('user.cumulativeIncome') }}</p><p>{{ eye==1 ? '+'+$t('utils.moneyMark')+data.all_lixi : '******' }}</p></div>
      </div>
    </div>
    <div class="kong" />
    <div class="user_yw">
      <div @click="$router.push('/order')">
        <img
          src="../images/user/order.png"
          alt=""
        >
        <p>{{ $t('user.myInvestment') }}</p>
      </div>
      <div @click="$router.push('/moneybag')">
        <img
          src="../images/user/details.png"
          alt=""
        >
        <p>{{ $t('user.transactionDetails') }}</p>
      </div>
      <div @click="$router.push('/kefu')">
        <img
          src="../images/user/kf.png"
          alt=""
        >
        <p>{{ $t('user.onlineService') }}</p>
      </div>
    </div>
    <div class="money">
      <div>
        <p>{{ $t('user.availableBalance') }}</p>
        <p>{{ $t('utils.moneyMark') }}{{ data.money }}</p>
      </div>
      <div>
        <span @click="$router.push('/invest')">{{ $t('user.recharge') }}</span>
        <span @click="$router.push('/cash')">{{ $t('user.withdraw') }}</span>
      </div>
    </div>
    <div class="list">
      <van-cell
        is-link
        @click="$router.push('/moneybag')"
      >
        <template #title>
          <img
            src="../images/user/moneybag.png"
            alt=""
          >
          <span class="custom-title">{{ $t('user.myWallet') }}</span>
        </template>
      </van-cell>
      <van-cell
        is-link
        @click="$router.push('/yuebao')"
      >
        <template #title>
          <img
            src="../images/user/yuebao.svg"
            alt=""
          >
          <span class="custom-title">{{ $t('yuebao.title') }}</span>
        </template>
      </van-cell>
      <van-cell
        is-link
        @click="$router.push('/rechargeRecord')"
      >
        <template #title>
          <img
            src="../images/user/cz.png"
            alt=""
          >
          <span class="custom-title">{{ $t('user.rechargeRecord') }}</span>
        </template>
      </van-cell>
      <van-cell
        is-link
        @click="$router.push('/withdrawRecord')"
      >
        <template #title>
          <img
            src="../images/user/tx.png"
            alt=""
          >
          <span class="custom-title">{{ $t('user.withdrawalRecord') }}</span>
        </template>
      </van-cell>
    </div>
    <div class="list">	
      <van-cell
        is-link
        @click="$router.push('/myTeam')"
      >
        <template #title>
          <img
            src="../images/about/icon8.png"
            alt=""
          >
          <span class="custom-title">{{ $t('index.invite') }}</span>
        </template>
      </van-cell>
      <van-cell
        is-link
        @click="$router.push('/realAuth')"
      >
        <template #title>
          <span
            class="real-auth-icon"
            aria-hidden="true"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 256 256"
            >
              <path
                fill="currentColor"
                d="M200 24H56a16 16 0 0 0-16 16v176a16 16 0 0 0 16 16h144a16 16 0 0 0 16-16V40a16 16 0 0 0-16-16m0 192H56V40h144ZM88 96a40 40 0 1 1 40 40a40 40 0 0 1-40-40m16 0a24 24 0 1 0 24-24a24 24 0 0 0-24 24m-24 80a8 8 0 0 1 8-8h80a8 8 0 0 1 0 16H88a8 8 0 0 1-8-8"
              />
            </svg>
          </span>
          <span class="custom-title">实名认证</span>
        </template>
      </van-cell>
      <van-cell
        is-link
        @click="$router.push('/safe')"
      >
        <template #title>
          <img
            src="../images/user/setting.png"
            alt=""
          >
          <span class="custom-title">{{ $t('user.setting') }}</span>
        </template>
      </van-cell>
    </div>
  </div>
</template>

<script>
	import Vue from 'vue';
	import qs from 'qs';
	import Fetch from '../../utils/fetch';
	import Api from "../../interface/index";
	import {
		Icon,
		Cell, 
		CellGroup 
	} from "vant";

	Vue.use(Cell).use(CellGroup).use(Icon);

	export default {
		name: "User",
		components: {
		},
		data() {
			return {
				data: {},
				eye:1
			};
		},
		created() {
			this.$parent.footer('user');
		},
		mounted() {
			this.start();
		},
		methods: {
			start() {
				Fetch('/user/info').then((r) => {
					this.data = r.data;
				}).catch(() => {});
			},
		}
	};
</script>

<style lang="less" scoped>
	.user_wrap {
		background-color: #FAFAFA;
		max-width: 100%;
		overflow: hidden;
	}
	.top_header {
		position: relative;
		width: 100%;
		height: 312px;
		padding-top: 28px;
		background: #3775f4;
		color: #fff;
		.set_go {
			position: absolute;
			top: 24px;
			right: 20px;
			width: 34px;
			height: 34px;
			color: #fff;
			svg { width: 100%; height: 100%; }
		}
		.user_detail {
			display: flex;
			align-items: center;
			padding: 15px 75px 0 20px;
			.user_header {
				width: 48px;
				height: 48px;
				flex: none;
				display: flex;
				align-items: center;
				justify-content: center;
				border-radius: 50%;
				background: rgba(255,255,255,.25);
				color: #fff;
				svg { width: 30px; height: 30px; }
			}
			.identity { margin-left: 12px; min-width: 0; }
			.identity_line { display: flex; align-items: center; flex-wrap: wrap; line-height: 24px; }
			.display_name { font-size: 17px; font-weight: bold; }
			.credit_score { font-size: 16px; font-weight: bold; }
			.vip_greeting { margin-top: 5px; color: rgba(255,255,255,.75); font-size: 14px; }
		}
		.user_balance {
			margin-top: 25px;
			text-align: center;
			.balance_label { color: rgba(255,255,255,.72); font-size: 14px; }
			.balance_label .van-icon { margin-left: 5px; vertical-align: -2px; font-size: 18px; }
			.balance_amount { margin-top: 10px; font-size: 31px; line-height: 40px; font-weight: bold; }
		}
		.user_money {
			display: flex;
			justify-content: space-between;
			margin-top: 21px;
			text-align: center;
			div { width: 33.33%; }
			p:first-child { color: rgba(255,255,255,.72); font-size: 14px; }
			p:last-child { margin-top: 8px; color: #fff; font-size: 15px; font-weight: bold; }
		}
	}
	.kong{
		width: 100%;
		height: 35px;
		background: #FFFFFF;
	}
	.user_yw{
		display: flex;
		justify-content: space-between;
		text-align: center;
		width: 96%;
		position: relative;
		top: -83px;
		background: #FFFFFF;
		left: 2%;
		border-radius: 5px 5px 0 0;
		padding: 15px 0;
		div{
			width: 33.33%;
		}
		p{
			margin-top: 8px;
		}
		img {
			width: 30px;
			height: 30px;
		}
	}
	.money{
		display: flex;
		justify-content: space-between;
		width: 96%;
		background: #FFFFFF;
		border-radius: 5px;
		margin-top: -73px;
		margin-left: 2%;
		padding: 15px;
		div:nth-child(1){
			width: 40%;
			text-align: left;
			p:nth-child(1){
				color: #999;
				margin-bottom: 10px;
			}
			p:nth-child(2){
				font-size: 14px;
				font-weight: bold;
			}
		}
		div:nth-child(2){
			width: 60%;
			text-align: right;
			margin-top: 12px;
			span{
				padding: 5px 10px;
				border-radius: 5px;
				margin: 0 5px;
			}
			span:nth-child(1){
				color: #FFFFFF;
				background: #3775f4;
			}
			span:nth-child(2){
				color: #3775f4;
				background: #e9f0fb;
			}
		}
	}
	.list{
		width: 96%;
		margin-left: 2%;
		margin-top: 10px;
		border-radius: 5px;
		img{
			vertical-align: middle;
			height: 30px;
			width: 30px;
			margin-right: 10px;
		}
		.real-auth-icon {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			width: 30px;
			height: 30px;
			margin-right: 10px;
			vertical-align: middle;
			border-radius: 7px;
			background: #eaf1ff;
			color: #3775f4;
			svg { width: 22px; height: 22px; }
		}
	}
	
</style>
